export const ERROR_CODES = {
  ACTIVO2_0004: 'Activo2-0004'
};
